import * as t from 'io-ts'

import {isRight} from 'fp-ts/lib/Either'
import reporter from 'io-ts-reporters'

type Valid<C> = {
  valid: true
  data: C
}

type Invalid = {
  valid: false
  errors: string[]
}

export const validate = <C>(
  data: unknown,
  codec: t.Type<C>
): Valid<C> | Invalid => {
  const result = codec.decode(data)

  if (!isRight(result)) {
    return {valid: false, errors: reporter.report(result)}
  }

  return {valid: true, data: result.right}
}
